/* eslint-disable no-param-reassign */
export default function dropUndefined(obj, recursive = false) {
    if (!obj || typeof obj !== 'object')
        return obj;
    Object.keys(obj).forEach((key) => {
        const item = obj[key];
        if (typeof item === 'undefined')
            delete obj[key];
        if (recursive && item && typeof item === 'object')
            dropUndefined(item, true);
    });
    return obj;
}
